// @flow

import _ from 'lodash';
import React, { PureComponent, type Node } from 'react';

import { CORE_PRODUCT_TYPES_LIST } from 'client/constants/productTypes';
import { titleCase } from 'client/utils/format';
import Translate from 'client/components/translate';

type Props = {
  effectiveDate?: Node,
  shouldLabelAsInsurance: boolean,
  type: string,
};

export default class PlanTypeAndDate extends PureComponent<Props> {
  static defaultProps = {
    effectiveDate: null,
    shouldLabelAsInsurance: false,
  };

  render() {
    const { effectiveDate, shouldLabelAsInsurance, type } = this.props;
    const typeLabel = shouldLabelAsInsurance ? 'Insurance' : 'Plan';

    let typeCopy = `${titleCase(type)} ${typeLabel}`;

    if (_.includes(CORE_PRODUCT_TYPES_LIST, type)) {
      typeCopy = <Translate path={`app.planCard.${type}${typeLabel}`} />;
    }

    return (
      <div>
        <div className="flex-row collapse neutral-text-color card-plan-type">
          <div>
            <strong>{typeCopy}</strong>
          </div>
          {effectiveDate && (
            <div className="flex-child-expand right hide-for-medium text-right">
              {effectiveDate}
            </div>
          )}
        </div>
        {effectiveDate && (
          <div className="hide-for-small-only card-effective-date">{effectiveDate}</div>
        )}
      </div>
    );
  }
}
